import React, { useState } from "react";
import styled from "styled-components";
import About from "../../pages/About";
import { HIMALogo } from "@origo/sp-lib";

const StyledLogo = styled(HIMALogo)`
  width: 5.4rem;
  height: 2.7rem;
`;

export const AboutButton: React.FC = () => {
  const [showAbout, setShowAbout] = useState(false);

  return (
    <div>
      <StyledLogo
        onClick={() => setShowAbout(!showAbout)}
      ></StyledLogo>
      {showAbout && <About onClose={() => setShowAbout(!showAbout)} />}
    </div>
  );
};
